module.exports = __webpack_public_path__ + "static/media/15.1fe9906e.jpg";